import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Review } from "@/services/bedrock";
import { SplitView } from "@/components/ui";
import { ReviewPanel, ReviewList } from "@/containers/Players/Reputation/components/ReviewInbox/components";
import { ShareFlowHost } from "@/components/ShareDesignPost/ShareFlowHost";
import { readSelectedReviewParam, writeSelectedReviewParam } from "@/components/ShareDesignPost/shareSearchParams";
import { ReviewFiltersProvider } from "./ReviewFiltersContext";

export interface ReviewInboxProps {
  playerId?: number | null;
  onShareReviewLink?: () => void;
}

export function ReviewInbox({ playerId = null, onShareReviewLink }: ReviewInboxProps) {
  const history = useHistory();
  const location = useLocation();
  // The selection lives in ?review= so a reload (mid share flow too) comes back to the same review;
  // until the list or the panel's details query loads it, only its id is known.
  const [selectedReview, setSelectedReview] = useState<Review | null>(() => {
    const reviewId = readSelectedReviewParam(location.search);
    return reviewId != null ? ({ id: String(reviewId) } as Review) : null;
  });
  const [listState, setListState] = useState({ isLoading: true, reviewsCount: 0 });

  useEffect(() => {
    writeSelectedReviewParam(history, location, selectedReview ? Number(selectedReview.id) : null);
  }, [selectedReview?.id]);

  return (
    <ReviewFiltersProvider>
      <div className="flex flex-col flex-1 w-full overflow-hidden min-h-0 px-4 pb-4">
        <ShareFlowHost playerId={playerId}>
          <SplitView className="flex-1 h-full">
            <ReviewList
              playerId={playerId}
              selectedReview={selectedReview}
              setSelectedReview={setSelectedReview}
              onListStateChange={(isLoading, reviewsCount) => {
                setListState({ isLoading, reviewsCount });
              }}
            />

            <ReviewPanel
              selectedReview={selectedReview}
              isLoading={listState.isLoading}
              reviewsCount={listState.reviewsCount}
              onShareReviewLink={onShareReviewLink}
            />
          </SplitView>
        </ShareFlowHost>
      </div>
    </ReviewFiltersProvider>
  );
}
